import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import axios from "./axios-order";
import IdleDetector from "react-idle-detector";

import Login from "./components/login/login";
import Registration from "./components/registration/registration";
import Layout from "./HOC/layout/layout";
import LandingPage from "./HOC/layout/landingCWS";
import { Redirect } from "react-router";

// import SampleEinvoice from "./Containers/sample-einvoice";

// Home
import Home from "./Containers/home/home";
import personalProfile from "./Containers/home/PersonalInfo/PersonalInfo";
import UserManagement from "./Containers/home/UserMgmt/UserMgmt";
import PendingRequest from "./Containers/home/PendingRequest/pendingRequest";
import BusinessEntityMgmt from "./Containers/home/BusinessEntityMgmt/BusinessEntityMgmt";
import Faq from "./Containers/home/Faq/Faq";
//Home-> Business entity mgmt ->
import assignUser from "./Containers/home/BusinessEntityMgmt/Assign_user/AssignUser";
import assignNewUser from "./Containers/home/BusinessEntityMgmt/Assign_user/addNewUser";
import AssignServices from "./Containers/home/BusinessEntityMgmt/AssignServices/assignServices";
// Home->Enviroment config
import EnviromentCreditEvalution from "./Containers/home/EnviromentConfig/CreditEvalution/CreditEvalution";
import TDSPayablesSetting from "./Containers/home/EnviromentConfig/TDSPayble/tdspayablePage";
import ComplianceGroup from "./Containers/home/EnviromentConfig/ComplianceMonitor/compliancePage";
// GST Invoice Type
import GSTInvoicetype from "./Containers/home/EnviromentConfig/GSTInvoiceType/GSTInvoicetype";
import GSTRepositoryMapping from "./Containers/home/EnviromentConfig/GSTRepositoryMapping/GSTRepositoryMapping";
import ZohoTdsMapping from "./Containers/home/EnviromentConfig/ZohoTdsMapping/ZohoTdsMapping";
import TrackFilingStatus from "./Containers/home/EnviromentConfig/TrackFilingStatus/TrackFilingStatus";

//E-INVOICE
import einvoice from "./Containers/E-INVOICE/einvoice";
import Summary from "./Containers/E-INVOICE/Summary";
import EinvoicePreValidation from "./Containers/E-INVOICE/EinvoicePreValidation";
import EinvoiceDashBoard from "./Containers/E-INVOICE/EinvoiceDashBoard";
// Credit Evalution
import DashboardCreditEvalution from "./Containers/CreditEvalution_dashboard/CreditEvalution";

// Business Entity details
import BusinessEntityDetails from "./Containers/BusinessEntityDetails/BusinessEntityDetails";

// Invoice Entries
import InvoiceCollectionEntries from "./Containers/Dashboards/agencyReport/CollectionEn/Dashboard";
import InvoiceDiscountingEntries from "./Containers/Dashboards/agencyReport/DiscountingEn/Dashboard";

// IC-Origa
import OrigaBatch from "./Containers/IC/Origa/OrigaBatch/OrigaBatch";
import OrigaBatchList from "./Containers/IC/Origa/OrigaBatchList/OrigaBatchList";
import OrigaFeedback from "./Containers/IC/Origa/OrigaFeedback/OrigaFeedback";
import OrigaInvoiceReceipt from "./Containers/IC/Origa/OrigaInvoiceReceipt/OrigaInvoiceReceipt";

// ID-Billionsloans
import BLOnboarding from "./Containers/ID/BillionLoans/Onboarding/Onboarding";
import InvoiceAuthorization from "./Containers/ID/BillionLoans/InvoiceAuthorization/InvoiceAuthorization";
import InvoiceFinancing from "./Containers/ID/BillionLoans/InvoiceFinancing/InvoiceFinancing";
import BuyerOnboarding from "./Containers/ID/BillionLoans/BuyerOnboarding/BuyerOnboarding";

// IARS
import IarsLogIn from "./Containers/Iars/IarsLogIn";
import Executivesummary from "./Containers/Iars/exectiveSummary/Executivesummary";
import Reasonwise from "./Containers/Iars/resonwisewise/Reasonwise";
import DamageStockSummary from "./Containers/Iars/Damagesummary/DamageStockSummary";

// ZOHO
import Zoho from "./Containers/Zoho/Zoho";

//ARC_Upload
// -->Sales
import ARCCustomer from "./Containers/ARC_Upload/sales/BussinessCustomerMang/BussinessCustomerMang";
import ARCCustomerData from "./Containers/ARC_Upload/sales/BussinessCustomerMang/showDetails";
import ARCCollections from "./Containers/ARC_Upload/sales/Collections/Collections";
import ARCInvoiceManagement from "./Containers/ARC_Upload/sales/InvoiceManagement/InvoiceManagement";
import ARCPaymentAdvice from "./Containers/ARC_Upload/sales/PaymentAdvice/PaymentAdvice";
// -->Purchase
import VenderManagement from "./Containers/ARC_Upload/Purchase/VendorManagement/VenderManagement";
import VendorpaymentAdvice from "./Containers/ARC_Upload/Purchase/VendorPaymentsAdvice/VendorpaymentAdvice";
import PurchaseInvoiceMgmt from "./Containers/ARC_Upload/Purchase/BillManagement/PurchaseMgmt";
import VendorCollections from "./Containers/ARC_Upload/Purchase/Collections/Collections";
// -->Agency Transaction
import ARCCollectionAgency from "./Containers/ARC_Upload/AgencyTransaction/CollectionAgency/CollectionAgency";
import ARCCollectionAgencyTransactions from "./Containers/ARC_Upload/AgencyTransaction/CollectionAgencyTransactions/CollectionAgencyTransactions";
import ARCIDAgency from "./Containers/ARC_Upload/AgencyTransaction/InvoiceDiscountingAgency/InvoiceDiscountingAgency";
import ARCInvoiceDiscounting from "./Containers/ARC_Upload/AgencyTransaction/InvoiceDiscounting/InvoiceDiscounting";
import Report9 from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/ReportPageForGSTR9/Report9";
// Dashbaords
// -->Sales
// ageing summary v1-
// import AgeingReceivable from "./Containers/Dashboards/sales/ageingSummaryV1/Dashboard";

// import InvoiceSummary from "./Containers/Dashboards/sales/invoiceSummary/Dashboard";
import InvoiceDashboardTableDetails from "./Containers/Dashboards/sales/invoiceSummary/ShowDetails";
// import UnallocatedPayment from "./Containers/Dashboards/sales/UnallocatedPayments/unallocatedPayments";
// import AgeingSummaryDashboardv2 from "./Containers/Dashboards/sales/ageingSummary/dashboard";
// import AppBarForCfoDebtorsStatus from "./Containers/Dashboards/sales/DebtorsStatus/AppBarForCfoDebtorsStatus";
// import controlReportSale from "./Containers/Dashboards/sales/controlReport/controlReport";
// import controlReport2Sale from "./Containers/Dashboards/sales/controlReport/controlReport2";
// -->Purchase
// ageing summary v1-
// import vendorAgeingSummaryDashboard from "./Containers/Dashboards/purchase/ageingSummaryV1/Dashboard";

// import AgeingPayablesDashboardV2 from "./Containers/Dashboards/purchase/ageingSummary/dashboard";
import VendorInvoiceSummary from "./Containers/Dashboards/purchase/billSummary/dashboard";
import VendorInvoiceDashboardTableDetails from "./Containers/Dashboards/purchase/billSummary/showInvoiceDetails";
// import PayCycleSummaryDashboard from "./Containers/Dashboards/purchase/payCycleSummary/Dashboard";
// import ControlReport from "./Containers/Dashboards/purchase/controlreport/ControlReport";
// import ControlReport2 from "./Containers/Dashboards/purchase/controlreport/ControlReport2";

//ARC_Reconciliation
//Sales
import Gstprevalidation from "./Containers/ARC_Reconciliation/Sales/GstPreValidation/Gstprevalidation";
import GSTRepo from "./Containers/ARC_Reconciliation/Sales/GSTR-1_Repository/GSTRepo";
//GSTR-1_Reconciliation
import GSTReonciliation from "./Containers/ARC_Reconciliation/Sales/GST-1_Reconciliation/GSTReconciliation";
import gstReconUpdatedTabDetails from "./Containers/ARC_Reconciliation/Sales/GST-1_Reconciliation/updatedShow";
import gstReconTableDetails from "./Containers/ARC_Reconciliation/Sales/GST-1_Reconciliation/showDetails";
import Gstr_1_save from "./Containers/ARC_Reconciliation/Sales/GSTR1-Save/gstr1_Save";
//End
import BankReconciliation from "./Containers/ARC_Reconciliation/Sales/RecepitReconciliation/BankReconciliation";
import BankReconDetails from "./Containers/ARC_Reconciliation/Sales/RecepitReconciliation/BankReconDetails";

//Old
// import TDSRcon from "./Containers/TDSReconciliation/TDSReconciliation";
// import TdsReport from "./Containers/TDSReconciliation/ReportPage";
//End

import TDSRconSaleV from "./Containers/ARC_Reconciliation/Sales/TDSReconciliationSale/TDSReconciliation";
import TdsReportSaleV from "./Containers/ARC_Reconciliation/Sales/TDSReconciliationSale/ReportPage";
import Form26as from "./Containers/ARC_Reconciliation/Sales/Form26as/form26asRepo";
import Form26asTableDetails from "./Containers/ARC_Reconciliation/Sales/Form26as/showDetails";

//Purchase
import GSTR2BPrevalidaion from "./Containers/ARC_Reconciliation/Purchase/GSTR2_Prevalidation/GSTR2BPrevalidation";
import Gst2aRepository from "./Containers/ARC_Reconciliation/Purchase/GSTR-2A_Repository/Gst2aRepository";
import Gstr3bRepository from "./Containers/ARC_Reconciliation/Purchase/GSTR-3B-Repository/Gstr3bRepositry";
//GSTR-2A_Reconciliation
import Gst2aReconciliation from "./Containers/ARC_Reconciliation/Purchase/GSTR-2A_Reconciliation/Gst2aReconciliation";
import Trial from "./Containers/ARC_Reconciliation/Purchase/GSTR-2A_Reconciliation/ReportPage/Trial";
import Gst2aReconciliationReport from "./Containers/ARC_Reconciliation/Purchase/GSTR-2A_Reconciliation/ReportPage/Report";
//End
import Gstr2bRepository from "./Containers/ARC_Reconciliation/Purchase/GSTR2B_Repository/Gstr2bRepository";
//GSTR-2B_Reconciliation
import Gstr2bReconciliation from "./Containers/ARC_Reconciliation/Purchase/GSTR2B_reconciliation/Gstr2bReconciliation";
import Gstr2bReconciliationReport from "./Containers/ARC_Reconciliation/Purchase/GSTR2B_reconciliation/ReportPage/Report";
import Gstr6aReconciliationReport from "./Containers/ARC_Reconciliation/Purchase/Gstr6a_Reconciliation/ReportPage/Report";
import Gst2aStatus from "./Containers/ARC_Reconciliation/Purchase/GSTR-2A_Reconciliation/Gst2aStatus";

import Gstr9Reconciliation from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/Gstr9Reconciliation";

//End
import TdsReconciliationGst2a from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/TdsReconciliationGst2a";
import TdsProvision from "./Containers/ARC_Reconciliation/Purchase/provision/provision";
import GSTR_3B_Recon from "./Containers/ARC_Reconciliation/Purchase/GSTR-3B_Reconciliation/GSTR_3B_Recon";
import Report from "./Containers/ARC_Reconciliation/Purchase/GSTR-3B_Reconciliation/ReportPageForGSTR3B/Report";

import Reporting from "./Containers/Reporting/Reporting";

import UploadTallyBackUpFile from "./Containers/UploadTallyFile/UploadTallyBackUpFile";

import MdmPage from "./Containers/MDM/mdm";
import ReportingLogs from "./Containers/ReportingLogs/ReportingLogs";
import MSME from "./Containers/MSME Page/MSME";
import Form26ASTDSRecon from "./Containers/ARC_Reconciliation/Sales/TDSReconciliationSale/26ASrecon";
import Form26asreport from "./Containers/ARC_Reconciliation/Sales/TDSReconciliationSale/26ASreport";
import Form26AsPairing from "./Containers/ARC_Reconciliation/Sales/TDSReconciliationSale/26ASPairing";

import Gtsr9OutwardComparison from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/Outward";
import Gtsr9InwardComparison from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/inward";
import InwardSummaryDetails from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/InwardSummaryDetails";
import OutwardSummaryDetails from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/OutwardSummaryDetails";
import Gstr8ARepository from "./Containers/ARC_Reconciliation/Purchase/Gstr-8A_Repository/Gstr-8A_Repositery";

import ItcAvailReport from "./Containers/ARC_Reconciliation/Purchase/ITC_Avaial_Report/ItcReport";
import ItcReportContainer from "./Containers/ARC_Reconciliation/Purchase/ITC_Avaial_Report/Report";
import ItemWiseReportHsn from "./Containers/ARC_Reconciliation/Purchase/ItemWiseReport/ItemWiseReport";
import ItemWiseReportContainer from "./Containers/ARC_Reconciliation/Purchase/ItemWiseReport/Report";
import AgeingReportDashBoard from "./Containers/ARC_Reports/AgingReport/Ageing_Report_DashBoard";
import AgeingRecivableReport from "./Containers/ARC_Reports/AgingReport/Ageing_Recivable_Report";
import AgeingPaybleReport from "./Containers/ARC_Reports/AgingReport/Ageing_payble_Report";
import GSTComputationReport from "./Containers/ARC_Reconciliation/Purchase/GstComputationReport/Gst_computation_report";
import GstComputationDetailedReport from "./Containers/ARC_Reconciliation/Purchase/GstComputationReport/report";
import HsnSummaryReport from "./Containers/ARC_Reconciliation/Purchase/HSN Summary Report/HsnSummaryReport";
import HsnSummaryDetails from "./Containers/ARC_Reconciliation/Purchase/HSN Summary Report/HsnSummaryDetails";
import GstPayablityReport from "./Containers/ARC_Reconciliation/Purchase/GstComputationReport/payablity_report";
import Form26ASTCSRecon from "./Containers/ARC_Reconciliation/Sales/TCSReconciliation/recon";
import Form26asTCSreport from "./Containers/ARC_Reconciliation/Sales/TCSReconciliation/report";
import Form26AsTCSPairing from "./Containers/ARC_Reconciliation/Sales/TCSReconciliation/pairing";
import ItcReversalReport from "./Containers/ARC_Reconciliation/Purchase/ITC_Reversal_Report/itc_reversal";
import ItcReversalReportContainer from "./Containers/ARC_Reconciliation/Purchase/ITC_Reversal_Report/Report";
import tabelDetails from "./Containers/ARC_Reconciliation/Purchase/ITC_Reversal_Report/tableDetails";
import tableDetails from "./Containers/ARC_Reconciliation/Purchase/ITC_Reversal_Report/tableDetails";
import AisDashboard from "./Containers/AIS/AisDashboard";
import AisViewData from "./Containers/AIS/AisViewData";
import AisUpload from "./Containers/AIS/AisUpload";
import VendorCancellation from "./Containers/ARC_Reports/VendoreCancellation/VendorCancellation";
import VendorViewData from "./Containers/ARC_Reports/VendoreCancellation/VendorViewData";
import VendoreViewtable from "./Containers/ARC_Reports/VendoreCancellation/VendoreViewtable";
import TdsReport from "./Containers/ARC_Reports/TDS_Applicability_Report/TdsReport";
// C2C Report
import C2CReport from "./Containers/ARC_Reports/C2C/c2CReport";

import MultiMonth from "./Containers/ARC_Reports/MultiMonth/MultiMonth";
import EInvoiceRepository from "./Containers/ARC_Reconciliation/Sales/E_Invoice_Repository/e_invoice_repo";
import E_Invoice_Reconcilation from "./Containers/ARC_Reconciliation/Sales/E_Invoice_Reconcilation/e_invoicereconcilation";
import E_Invoice_Details from "./Containers/ARC_Reconciliation/Sales/E_Invoice_Reconcilation/E_Invoice_Details";
import GSTComputationReportDetails from "./Containers/ARC_Reconciliation/Purchase/GstComputationReport/reportDetails";
import AgeingPayableReport from "./Containers/ARC_Reports/AgingReport/Ageing_payble_Report";
import Form26ASExcelPairing from "./Containers/ARC_Reconciliation/Sales/TDSReconciliationSale/26ASExcelPairing";

import { LicenseInfo } from "@mui/x-data-grid-pro";
import GstLedgers from "./Containers/ARC_Reports/GSTLedger/GstLedger";
import GstLederDetailedReport from "./Containers/ARC_Reports/GSTLedger/ReportView";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RCMReport from "./Containers/ARC_Reconciliation/Purchase/RCM_Report/rcmReport";
import Gstr8aReconciliation from "./Containers/ARC_Reconciliation/Purchase/Gstr8A_reconciliation/Gstr8aReconciliation";

import LogTables from "./Containers/ARC_Reports/Form16/logtable";
import Form16Table from "./Containers/ARC_Reports/Form16/form16Table";

import CompanyTable from "./Containers/E-INVOICE/company/company";
import MasterTable from "./Containers/E-INVOICE/master/master";
import ServiceTable from "./Containers/E-INVOICE/service/service";
import ProductMaster from "./Containers/E-INVOICE/Product/product";
import Dashboard from "./Containers/E-INVOICE/dashboard/dashboard";
import GstrPanValidationTables from "./Containers/ARC_Reports/GstrPanValidation/gstrPanValidation";
import ArcDataUploads from "./Containers/ARC_Upload/DataUpload";
import ArcDataValidation from "./Containers/ARC_Reconciliation/DataValidation";
import ArcFiling from "./Containers/ARC_Reconciliation/Filing";
import ArcRepository from "./Containers/ARC_Reconciliation/Repository";
import ArcRecon from "./Containers/ARC_Reconciliation/Recon";
import IMSRepository from "./Containers/ARC_Reconciliation/Purchase/IMS_Repository/ImsRepository";
import IMSRepositoryOutward from "./Containers/ARC_Reconciliation/Sales/IMS-Repository/ImsRepositoryOutward";
import ArcReports from "./Containers/ARC_Reports/Reports";
import ArcEInvoice from "./Containers/E-INVOICE/E-Invoice";
import IARS from "./Containers/Iars/IARS";
import TdsLiabilities from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/tds_liabilities";
import TdsPayableDashBoard from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/tds_payable_dashboard";
import TdsLiabilityCalcutionData from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/tds_liability_calculation";
import TdsChallanAssociate from "./Containers/ARC_Reconciliation/Purchase/TDSChallanRepository/tds_challan_associate";
import Form26QFiling from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/form26QDetailsStep";
import Form24QFiling from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/form24QDetailsStep";
import IMSReconciliation from "./Containers/ARC_Reconciliation/Purchase/IMS_Reconcilation/imsReconcilation";
import IMSReconManualPairing from "./Containers/ARC_Reconciliation/Purchase/IMS_Reconcilation/imsReconManualParing";
import GSTR9CReportData from "./Containers/ARC_Reconciliation/Purchase/Gstr-9c Reconciliation/gstr9cReportData";
import InfographicCards from "./Containers/ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/gstr9Report/gstrReport9";
import IMSDashboard from "./Containers/ARC_Reconciliation/Sales/IMS_Outward_Recon/ImsDashboard";

import ComplianceMonitor from "./Containers/Compliance_Monitor/ComplianceMonitor";
import NoticeManagement from "./Containers/Notice_Management/NoticeManagement";
import ReportsCards from "./Containers/ARC_Reports/ReportsCards";
import ReconCards from "./Containers/ARC_Reconciliation/ReconCards";
import Template from "./Containers/E-INVOICE/TaxInvoice/template";
import GSTRepositoryMain from "./Containers/ARC_Reconciliation/Sales/GSTR-1_Repository/GSTRepositoryMain";
import RepoCards from "./Containers/ARC_Reconciliation/RepoCards";
import Gstr6aRepository from "./Containers/ARC_Reconciliation/Purchase/GSTR6A_Repository/Gstr6aRepository";
import Gstr6aReconciliation from "./Containers/ARC_Reconciliation/Purchase/Gstr6a_Reconciliation/Gstr6aReconciliation";
import EWayBill from './Containers/E-INVOICE/TaxInvoice/EWayBill';
import WhiteLabel from "./Containers/home/EnviromentConfig/whiteLabel/whiteLabel";
import Form27QFiling from "./Containers/ARC_Reconciliation/Purchase/TDS_Payables_Reconciliation/27Q/form27qDetailsStep";
import Gstr1aFilingLogReport from "./Containers/Reporting_Gstr1a/subdata";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE_KEY);

const noActivityHandler = () => {
  let token = localStorage.getItem("token");
  if (token) {
    alert("Your session is timed out.Please login again");
    const userid = localStorage.getItem("user_id");
    axios
      .get(`/logout/${userid}`)
      .then((res) => {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("user_id");
        localStorage.removeItem("business_entity_id");
        localStorage.removeItem("user_name");
        window.location.href = "/login";
      })
      .catch((error) => {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("user_id");
        localStorage.removeItem("business_entity_id");
        localStorage.removeItem("user_name");
        window.location.href = "/login";
      });
  }
};

class App extends Component {
  render() {
    return (
      /* The above code is a React component that includes a ToastContainer component for displaying
      notifications. It also includes an IdleDetector component that listens for mousemove events
      and triggers a callback function (noActivityHandler) when there is no activity for a certain
      period of time. The idle time is set based on the environment variable REACT_APP_MODE, with a
      default value of 1200000 milliseconds (20 minutes) and a longer time of 24 hours in DEBUG
      mode. */
      <React.Fragment>
        <ToastContainer />
        {window.navigator.onLine ? (
          <IdleDetector
            events={["mousemove", "keydown", "mousedown", "scroll"]} // Array of listen events
            onNoActivity={noActivityHandler} // callback on no activity
            // idleTime={process.env.REACT_APP_MODE === "DEBUG" ? 24 * 60 * 60 * 1000 : 1200000} // no activity time, ms
            idleTime={1800000}
          >
            <Switch>
              <Route path="/" exact component={Login} />

              <Route path="/login" exact component={Login} />

              <Route path="/Registration" exact component={Registration} />

              <Route path="/home" exact component={Home} />

              {/* <ProtectedRoute path="/home" component={Home} /> */}

              <Route path="/userManagement" component={UserManagement} />

              <Route
                path="/businessEntityMgmt"
                component={BusinessEntityMgmt}
              />

              <Route
                path="/enviromentCreditEvalution"
                component={EnviromentCreditEvalution}
              />

              <Route path="/faq" component={Faq} />

              <Route
                path="/enviromentTdsPayable"
                component={TDSPayablesSetting}
              />
              <Route path="/enviromentCompliance" component={ComplianceGroup} />

              <Route path="/GSTInvoicetype" component={GSTInvoicetype} />
              <Route path="/zohoTdsMapping" component={ZohoTdsMapping} />
              <Route path="/TrackFilingStatus" component={TrackFilingStatus} />
              <Route
                path="/whiteLabel"
                component={WhiteLabel}
              />
              <Route
                path="/GSTRepositoryMapping"
                component={GSTRepositoryMapping}
              />

              <Route path="/pendingRequest" component={PendingRequest} />

              <Route
                path="/businessEntityManagement/assignUser"
                component={assignUser}
              />

              <Route path="/personalProfile" component={personalProfile} />

              <Route
                path="/businessEntityManagement/addNewUser"
                component={assignNewUser}
              />

              <Route
                path="/businessEntityManagement/assignServices"
                component={AssignServices}
              />

              {/* <Route path="*" component={NotFoundPage} /> */}

              <Layout>
                <Route
                  path="/dashboardCreditEvalution"
                  component={DashboardCreditEvalution}
                />
                <Route path="/TDSProvision" component={ReconCards} />
                <Route
                  path="/GSTR_3B_Reconciliation"
                  component={GSTR_3B_Recon}
                />

                <Route path="/GSTR_3B_Repository" component={ArcRepository} />

                <Route path="/Outward_comparison" component={ReportsCards} />

                <Route path="/Inward_comparison" component={ReportsCards} />

                <Route path="/GSTR_9Reconciliation" component={ReconCards} />

                <Route path="/GSTR_9CReconciliation" component={ReconCards} />

                <Route
                  path="/complianceMonitor"
                  component={ComplianceMonitor}
                />

                <Route path="/NoticeManagement" component={NoticeManagement} />

                <Route
                  path="/GSTR_9CReconciliationdata"
                  component={GSTR9CReportData}
                />

                <Route path="/GSTR_3B_ReportingPage" component={Report} />
                <Route
                  path="/GSTR9-ReportingPage/:reconId"
                  component={InfographicCards}
                />

                {/* <Route
                  path="/AgeingReceivablesSummary"
                  component={AgeingReceivable}
                /> */}

                {/* <Route
                  path="/AgeingReceivablesSummaryDashboardv2"
                  component={AgeingSummaryDashboardv2}
                /> */}

                {/* <Route
                  path="/vendorAgeingSummaryDashboardV2"
                  component={AgeingPayablesDashboardV2}
                /> */}

                {/* <Route 
                  path="/InvoiceSummary" 
                  component={InvoiceSummary}
                /> */}

                {/* vendor route */}
                <Route
                  path="/vendorInvoiceSummary"
                  component={VendorInvoiceSummary}
                />

                {/* <Route
                  path="/vendorAgeingSummary"
                  component={vendorAgeingSummaryDashboard}
                /> */}

                <Route
                  path="/vendorInvoiceDashboardTableDetails"
                  component={VendorInvoiceDashboardTableDetails}
                />

                {/* <Route
                  path="/payCycleSummaryDashboard"
                  component={PayCycleSummaryDashboard}
                /> */}

                {/* <Route
                  path="/unallocatedPayments"
                  component={UnallocatedPayment}
                /> */}

                <Route
                  path="/invoiceCollectionEntries"
                  component={InvoiceCollectionEntries}
                />
                <Route path="/Data-Upload" component={ArcDataUploads} />
                <Route path="/Data-Validation" component={ArcDataValidation} />
                <Route path="/Filing" component={ArcFiling} />
                <Route path="/Repository" component={ArcRepository} />
                <Route path="/Recon" component={ArcRecon} />
                <Route path="/Reports" component={ArcReports} />
                <Route path="/ArcEinvoice" component={ArcEInvoice} />
                <Route path="iarsloginDashboard" component={IARS} />
                <Route
                  path="/BusinessCustomerManagement"
                  component={ArcDataUploads}
                />
                <Route path="/ARCCustomerShow" component={ARCCustomerData} />
                <Route
                  path="/BusinessEntityDetails"
                  component={BusinessEntityDetails}
                />
                <Route path="/InvoiceManagement" component={ArcDataUploads} />
                <Route path="/PurchaseInvoiceMgmt" component={ArcDataUploads} />
                <Route path="/vendorCollections" component={ArcDataUploads} />
                <Route
                  path="/uploadInvoiceDiscountingAgencyData"
                  component={ARCIDAgency}
                />
                <Route
                  path="/uploadCollectionsData"
                  component={ArcDataUploads}
                />
                <Route
                  path="/uploadPaymentAdviceData"
                  component={ArcDataUploads}
                />
                <Route
                  path="/uploadCollectionAgenciesData"
                  component={ARCCollectionAgency}
                />
                <Route
                  path="/uploadCollectionAgencyTransactionsData"
                  component={ARCCollectionAgencyTransactions}
                />
                <Route
                  path="/uploadInvoiceDiscountingData"
                  component={ARCInvoiceDiscounting}
                />

                <Route path="/ReportingLogs" component={ReportingLogs} />

                <Route path="/msme-page" component={MSME} />
                {/* ---------gstr 1 Save (vyna) */}

                <Route path="/Gstr1Save" component={Gstr_1_save} />
                {/*...............App Bar For Cfo Debtors Status..............................*/}

                {/* <Route
                  path="/AppBarForCfo"
                  component={AppBarForCfoDebtorsStatus}
                /> */}

                {/*..............Gst2aRepository....................*/}
                <Route path="/Gst2aRepository" component={ArcRepository} />
                {/*.................Gst2aReconciliation.................*/}
                <Route path="/Gst2aReconciliation" component={ReconCards} />
                <Route path="/Trial" component={Trial} />
                <Route path="/Gst2aStaus" component={ArcRepository} />
                <Route path="/itcAvailReportBooks" component={ReportsCards} />
                <Route path="/sectionReport" component={ReportsCards} />

                <Route
                  path="/itcAvailReport/:reconId"
                  component={ItcReportContainer}
                />
                <Route path="/tdsApplicabilityReport" component={TdsReport} />
                <Route path="/rcmReport" component={ReportsCards} />
                <Route path="/bookvsgstLed" component={ReportsCards} />

                <Route path="/itemWiseReportHsn" component={ReportsCards} />

                <Route path="/reportCards" component={ReportsCards} />
                <Route path="/reconCards" component={ReconCards} />
                <Route path="/repoCards" component={RepoCards} />

                <Route
                  path="/itemWiseReportContainer/:reconId"
                  component={ItemWiseReportContainer}
                />

                <Route path="/itcRevarsalReport" component={ReportsCards} />

                <Route path="/VendorCancellation" component={ReportsCards} />
                <Route path="/MultiMonth" component={ReportsCards} />
                <Route path="/VendorViewData" component={VendorViewData} />

                <Route path="/VendoreViewtable" component={VendoreViewtable} />

                <Route
                  path="/itcRevarsalSummary/:reconId"
                  component={ItcReversalReportContainer}
                />

                <Route
                  path="/ageing_report_dashboard"
                  component={AgeingReportDashBoard}
                />

                <Route
                  path="/ageing_recivable_report_dashboard"
                  component={ReportsCards}
                />

                <Route
                  path="/ageing_payable_report_dashboard"
                  component={ReportsCards}
                />

                <Route
                  path="/gst_computation_report"
                  component={ReportsCards}
                />

                <Route
                  path="/gst_computation_report_data/:reconId"
                  component={GSTComputationReportDetails}
                />

                <Route
                  path="/gst_computation_report_details_data/:reconId"
                  component={GstComputationDetailedReport}
                />

                <Route path="/HsnSummaryReport" component={ReportsCards} />

                <Route
                  path="/HsnSummaryDetails"
                  component={HsnSummaryDetails}
                />

                <Route
                  path="/InwardSummaryDetails"
                  component={InwardSummaryDetails}
                />

                <Route
                  path="/OutwardSummaryDetails"
                  component={OutwardSummaryDetails}
                />

                <Route path="/RcmSummary" component={ReportsCards} />
                <Route
                  path="/GstrPanValidation"
                  component={ArcDataValidation}
                />

                <Route path="/tableDetails" component={tableDetails} />

                <Route path="/C2CReportDashboard" component={ReportsCards} />
                <Route path="/Form16" component={ReportsCards} />
                <Route path="/Form16Details/:job_id" component={Form16Table} />

                <Route path="/AisDashboard" component={ReconCards} />

                <Route path="/AisViewData" component={AisViewData} />
                <Route path="/AisUpload" component={ArcRepository} />

                <Route
                  path="/gst_computation_paybality_report_data/:reconId"
                  component={GstPayablityReport}
                />

                <Route path="/E-InvoiceRepo" component={ArcRepository} />

                <Route path="/IMSRepo" component={ArcRepository} />
                <Route path="/IMSRepoOutward" component={ArcRepository} />
                <Route path="/IMSReconciliation" component={ReconCards} />
                <Route
                  path="/IMSReconciliation_data/:ims_recon_id"
                  component={IMSReconciliation}
                />
                <Route
                  path="/IMSReconciliation_manualPairing"
                  component={IMSReconManualPairing}
                />

                <Route
                  path="/IMSOutwardReconciliation"
                  component={ReconCards}
                />

                <Route
                  path="/IMSOutwardReconciliation_data/:ims_outward_recon_id"
                  component={IMSDashboard}
                />

                <Route path="/e_invoicereconcilation" component={ReconCards} />

                <Route
                  path="/E_Invoice_Details"
                  component={E_Invoice_Details}
                />
                <Route
                  path="/gst2aReconReport"
                  component={Gst2aReconciliationReport}
                />
                <Route
                  path="/gstr2bReconciliationReport"
                  component={Gstr2bReconciliationReport}
                />
                <Route
                  path="/gstr6aReconciliationReport"
                  component={Gstr6aReconciliationReport}
                />
                <Route
                  path="/gstr8aReconciliationReport"
                  component={Gstr2bReconciliationReport}
                />
                {/*.............Gst 2a Recon and rep Gst-Prevalidation........................*/}
                <Route path="/gstPreValidation" component={ArcDataValidation} />
                {/*.................GST2A TDS REconciliation..................*/}
                <Route path="/Gst2aTdsReconciliation" component={ReconCards} />
                <Route path="/TdsLiabilities" component={TdsLiabilities} />
                <Route
                  path="/TdsPayableDashboard"
                  component={TdsPayableDashBoard}
                />
                <Route
                  path="/TdsLiabilityCalcutionData"
                  component={TdsLiabilityCalcutionData}
                />
                <Route path="/TDSChallanRepository" component={ArcRepository} />
                <Route
                  path="/TdsChallanAssociate"
                  component={TdsChallanAssociate}
                />
                {/*........................Iars LogIn Dashboard......................*/}
                <Route path="/iarsloginDashboard" component={IARS} />
                {/*........................E-INVOICE LogIn Dashboard......................*/}
                <Route path="/einvoice" component={ArcEInvoice} />
                <Route path="/company" component={CompanyTable} />
                <Route path="/master" component={MasterTable} />
                <Route path="/service" component={ServiceTable} />
                <Route path="/product" component={ProductMaster} />
                <Route path="/Summary" component={ArcEInvoice} />
                <Route path="/EinvoicePreValidation" component={ArcEInvoice} />
                <Route path="/EinvoiceDashBoard" component={ArcEInvoice} />
                <Route path="/invoice-template" component={Template} />
                {/* <Route path="/DashBoard" component={Dashboard} /> */}
                {/*........................Iars Executive Sumary.......................*/}
                <Route path="/iarsexecutivesummary" component={IARS} />
                {/*..........................Iars ReasonWise Report.......................*/}
                <Route path="/iarsreasonwise" component={IARS} />
                {/*............................Iars Damage Stock Summary...........*/}
                <Route path="/damagestocksummary" component={IARS} />
                {/*..........................Gstr2bRepository......................*/}
                <Route path="/Gstr8aRepository" component={ArcRepository} />
                <Route path="/Gstr8aReconciliation" component={ReconCards} />
                {/*.........................Gstr2bReconciliation...................*/}
                {/*..........................Gstr2bRepository......................*/}
                <Route path="/Gstr2bRepository" component={ArcRepository} />
                <Route path="/Gstr6aRepository" component={Gstr6aRepository} />
                {/*.........................Gstr2bReconciliation...................*/}
                <Route path="/Gstr2bReconciliation" component={ReconCards} />
                <Route
                  path="/Gstr6aReconciliation"
                  component={Gstr6aReconciliation}
                />
                {/*.................Gstr2b Prevalidation................*/}
                <Route
                  path="/Gstr2bPrevalidation"
                  component={ArcDataValidation}
                />
                <Route path="/zohoTesting" component={Zoho} />
                <Route
                  path="/invoiceDiscountingEntries"
                  component={InvoiceDiscountingEntries}
                />
                <Route path="/landingcws" component={LandingPage} />
                {/* <Route path="/TDSReconciliation" component={TDSRcon} /> */}
                <Route path="/TDSRepo" component={ArcRepository} />
                {/* <Route path="/TDSReport" component={TdsReport} /> */}
                {/* .........tds recon sale v 2 .......*/}
                <Route
                  path="/TDSReconciliationSaleV"
                  component={TDSRconSaleV}
                />
                <Route path="/26ASRecon" component={ReconCards} />
                <Route path="/26Pairing" component={Form26AsPairing} />
                <Route
                  path="/26ASExcelParing"
                  component={Form26ASExcelPairing}
                />
                <Route path="/TDSReportSaleV" component={TdsReportSaleV} />
                <Route path="/26ASReport" component={Form26asreport} />
                <Route path="/GSTRepo" component={ArcRepository} />
                <Route path="/GSTR1ARepo" component={ArcRepository} />
                <Route path="/Reporting" component={ArcFiling} />
                <Route path="/gstr1a-log-report/:reconId" component={Gstr1aFilingLogReport} />
                <Route path="/ReportingGTR1A" component={ArcFiling} />
                <Route path="/ReportingGSTR6" component={ArcFiling} />
                <Route path="/24QFiling" component={ArcFiling} />
                <Route path="/26QFiling" component={ArcFiling} />
                <Route path="/27QFiling" component={ArcFiling} />
                <Route path="/GstLedgers" component={ReportsCards} />
                <Route
                  path="/GstLederReport/:report_id"
                  component={GstLederDetailedReport}
                />
                {/* .........tcs recon .......*/}
                <Route path="/TCS/Recon/26AS" component={ReconCards} />
                <Route path="/TCS/Report/26AS" component={Form26asTCSreport} />
                <Route
                  path="/TCS/Pairing/26AS"
                  component={Form26AsTCSPairing}
                />
                <Route
                  path="/BankReconciliation"
                  component={BankReconciliation}
                />
                <Route path="/BankReconDetails" component={BankReconDetails} />
                <Route path="/GSTReconciliation" component={ReconCards} />
                <Route
                  path="/IntegratedGSTReconciliation"
                  component={ReconCards}
                />
                <Route
                  path="/gstReconTableDetails"
                  component={gstReconTableDetails}
                />
                <Route
                  path="/gstReconUpdatedTabDetails"
                  component={gstReconUpdatedTabDetails}
                />
                <Route
                  path="/form26asTableDetails"
                  component={Form26asTableDetails}
                />
                <Route path="/GSTRepositoryMain" component={ArcRepository} />

                <Route
                  path="/InvoiceDashboardTableDetail"
                  component={InvoiceDashboardTableDetails}
                />
                <Route path="/vendorManagement" component={ArcDataUploads} />
                <Route path="/daybook" component={ArcDataUploads} />
                <Route path="/coa" component={ArcDataUploads} />
                <Route path="/employeeDetails" component={ArcDataUploads} />
                <Route
                  path="/tdsTransactionDetails"
                  component={ArcDataUploads}
                />
                <Route path="/nriDetails" component={ArcDataUploads} />
                <Route path="/VendorpaymentAdvice" component={ArcDataUploads} />
                {/* <Route path="/InvalidCrDrNote" component={ControlReport} /> */}
                {/* <Route
                  path="/InputTaxCrToBeReversed"
                  component={ControlReport2}
                /> */}
                <Route path="/BatchManagement" component={OrigaBatch} />
                <Route path="/BatchList" component={OrigaBatchList} />
                <Route path="/viewCollectionStatus" component={OrigaFeedback} />
                <Route path="/receipt" component={OrigaInvoiceReceipt} />
                <Route path="/Borroweronboarding" component={BLOnboarding} />
                <Route path="/Buyeronboarding" component={BuyerOnboarding} />
                <Route
                  path="/InvoiceAuthorization"
                  component={InvoiceAuthorization}
                />
                <Route path="/InvoiceFinancing" component={InvoiceFinancing} />
                {/* ......sales control report ........ */}

                {/* <Route
                  path="/InvalidCrDrNoteSale"
                  component={controlReportSale}
                /> */}

                {/* <Route
                  path="/InputTaxCrToBeReversedSale"
                  component={controlReport2Sale}
                /> */}

                <Route
                  path="/UploadTallyBackUpFile"
                  component={UploadTallyBackUpFile}
                />

                <Route path="/mdm" component={MdmPage} />

                <Route path="/26QFormFiling" component={Form26QFiling} />
                <Route path="/24QFormFiling" component={Form24QFiling} />
                <Route path="/27QFormFiling" component={Form27QFiling} />
                <Route path="/eway-bill/:id" component={EWayBill} />
              </Layout>
            </Switch>
          </IdleDetector>
        ) : (
          <div>Service Unavailable at the moment</div>
        )}
      </React.Fragment>
    );
  }
}

export default App;
